{
  "loading": "Загрузка...",
  "loadingMore": "Дополнительная загрузка..."
}